<template>
  <div class="time-table-filter">
    <div class="time-table-text-filter" style="margin-bottom: 8px;">
      <text-filter
        type="timeTable"
        field="text_filter"
        label="Поиск по названию, шифру или номеру договора"
      />
    </div>
    <div class="filters-container">
      <select-filter
        type="timeTable"
        field="customer"
        label="Заказчик"
        request="page/other_company"
        :parse-value="({ name }) => name"
        :filterable="true"
      />
      <select-filter
        type="timeTable"
        field="manager"
        label="Менеджер"
        :request="getUsersRequest()"
        :parse-value="getFullName"
        :filterable="true"
      />
      <select-filter
        type="timeTable"
        field="status"
        label="Статус"
        request="objectInfo/contract_statuses"
        :parse-value="({ name }) => name"
      />
      <sorting-control
        style="margin-left: 32px;"
        type="timeTable"
        :values="sortingFields"
      />
    </div>
  </div>
</template>

<script>
import TextFilter from './helpers/text-filter'
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'
import { getFullName } from '@/utils'
import { managersConfig } from '@/config/users'

const sortingFields = [
  { field: 'code', name: 'Шифр' },
  { field: 'date', name: 'Дата начала' }
]

export default {
  components: {
    TextFilter,
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields,
      getFullName
    }
  },
  methods: {
    getUsersRequest () {
      return `objectInfo/users?config=${JSON.stringify(managersConfig)}`
    }
  }
}
</script>

<style></style>
